class StatusesController {

    constructor($scope, $timeout) {
        this.$scope = $scope;
        this.$timeout = $timeout;
    }

    $onInit () {
        this.orderStatuses = [
            {
                key: 'payment',
                value: 'Payment step',
                group: 'Active'
            },
            {
                key: 'review',
                value: 'Review step',
                group: 'Active'
            },
            {
                key: 'pending_payment',
                value: 'Pending payment',
                group: 'Active'
            },
            {
                key: 'processing',
                value: 'Awaiting confirmation',
                group: 'Active'
            },
            {
                key: 'confirmed',
                value: 'Confirmed',
                group: 'Active'
            },
            {
                key: 'failed',
                value: 'Failed',
                group: 'Active'
            },
            {
                key: 'cancelled',
                value: 'Cancelled',
                group: 'Active'
            },
            {
                key: 'on_hold',
                value: 'On hold (Deprecated)',
                group: 'Deprecated'
            },
            {
                key: 'paid',
                value: 'Paid (Deprecated)',
                group: 'Deprecated'
            },
            {
                key: 'refunded',
                value: 'Refunded (Deprecated)',
                group: 'Deprecated'
            },
        ];

        this.paymentStatuses = [
            {
                key: '200',
                value: 'Payment successfully taken',
                group: 'Success'
            },
            {
                key: 'partial_refund',
                value: 'Payment partially refunded',
                group: 'Success'
            },
            {
                key: 'refunded',
                value: 'Payment fully refunded',
                group: 'Success'
            },
            {
                key: 'token',
                value: 'Checkout token was created successfully',
                group: 'Success'
            },
            // {
            //     key: 'manual_payment',
            //     value: 'Manual payment',
            //     group: 'Success'
            // },
            {
                key: 'token_error',
                value: 'Checkout token not created successfully',
                group: 'Error'
            },
            {
                key: '400',
                value: 'Bad request (400)',
                group: 'Error'
            },
            {
                key: '402',
                value: 'Request failed (402)',
                group: 'Error'
            },
            {
                key: '500',
                value: 'Payment gateway - internal error (500)',
                group: 'Error'
            },
            {
                key: '502',
                value: 'Payment gateway - bad gateway (502)',
                group: 'Error'
            },
            {
                key: '503',
                value: 'Payment gateway - service unavailable (503)',
                group: 'Error'
            },
            {
                key: '504',
                value: 'Payment gateway - timeout (504)',
                group: 'Error'
            },
        ];

        this.watchDisable();
    }

    watchDisable () {
        this.$scope.$watch(() => this.disable, (newVal, oldVal) => {
            if (newVal !== oldVal) {
                this.$timeout(() => {
                    this.$scope.$digest();
                }, 50);
            }
        });
    }

    groupStatus (item) {
        return item.group;
    }
}

StatusesController.$inject = ['$scope', '$timeout'];

export default StatusesController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/order/controllers/statuses.controller.js